// Generated by CoffeeScript 1.11.1
(function() {
  module.exports = {
    Greyscale: require('./image_modes/greyscale'),
    RGB: require('./image_modes/rgb'),
    CMYK: require('./image_modes/cmyk')
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./lib/psd/image_mode.js
// module id = 42
// module chunks = 0